import ButtonWithLink from '@gameday/react-components/components/ButtonWithLink'
import cn from 'classnames'
import { isFunction, noop } from 'lodash'

import styles from './styles.scss'

const NavigationButtons = ({
  hideBackButton,
  hideSubmitButton,
  previousPage,
  preventDefaultOnBack,
  submitLabel,
  onBack,
  onSubmit,
  isContinueDisabled,
  hideHr,
  nonStick,
  buttonColour,
  buttonTextColour,
  backButtonLabel,
}) => (
  <>
    {!hideHr && <hr className={styles.divider} />}

    <div
      className={cn(styles.navBtnWrapper, {
        [styles.nonStick]: nonStick,
      })}
    >
      {!hideBackButton ? (
        <ButtonWithLink
          backButton
          backButtonLabel={backButtonLabel}
          id="back-button"
          onClick={event => {
            if (isFunction(onBack)) {
              onBack(event)
            }
            if (!preventDefaultOnBack && isFunction(previousPage)) {
              previousPage()
            }
          }}
          className={styles.backButton}
        />
      ) : (
        <div />
      )}
      {!hideSubmitButton && (
        <ButtonWithLink
          id="submit-button"
          type="submit"
          onClick={onSubmit}
          label={submitLabel}
          color="primary"
          variant="contained"
          disabled={isContinueDisabled}
          className={styles.continueButton}
          buttoncolour={buttonColour}
          buttontextcolour={buttonTextColour}
          data-testid="nextButton"
        />
      )}
    </div>
  </>
)

NavigationButtons.defaultProps = {
  hideBackButton: false,
  hideSubmitButton: false,
  submitLabel: 'Next',
  onBack: null,
  onSubmit: noop,
  isContinueDisabled: false,
  hideHr: false,
  nonStick: false,
  preventDefaultOnBack: false,
}

export default NavigationButtons
